// graph/users/queries.js
import { gql } from "graphql-request";

export const READ_USER_BY_EMAIL = gql`
  query ReadUserByEmail($email: String!) {
    readUserByEmail(email: $email) {
      id
      firstName
      lastName
      email
      hourlyRate
      password
      verifiedEmail
      role
      tenantID
      contactID
      notes
      invitedBy
      createdAt
      updatedAt
      archivedAt
    }
  }
`;


export const READ_ADMINS = gql`
  query ReadUsersByRole($role: UserRole!) {
    readUsersByRole(role: $role) {
      id
      firstName
      lastName
    }
  }
`;


export const READ_ALL_USERS = gql`
  query {
    readAllUsers {
      id
    firstName
    lastName
    email
    hourlyRate
    password
    verifiedEmail
    role
    tenantID
    contactID
    notes
    invitedBy
    createdAt
    updatedAt
    archivedAt
    }
  }
`;

export const READ_USER_BY_ID = gql`
  query ReadUserByID($id: ID!) {
    readUserByID(id: $id) {
      id
      firstName
      lastName
      email
      hourlyRate
      verifiedEmail
      role
      tenantID
      contactID
      notes
      invitedBy
      createdAt
      updatedAt
      archivedAt
    }
  }
`;


export const READ_USERS_BY_TENANT_ID = gql`
  query ReadUsersByTenantID($tenantID: ID!) {
    readUsersByTenantID(tenantID: $tenantID) {
      id
      firstName
      lastName
      email
      role
      tenantID
      archivedAt
    }
  }
`;